<template>
  <div :class="main_show!=2?'bd_y':'bd_x'" v-if="show_body">
    <div class="top clearfix">
      <div class="top_left clearfix">
        <div class="rq">
          <span>{{friend_rq}}</span>
          <br/>影响力
        </div>
        <div class="ry">
          <h1>{{data.nickname}}</h1>
          <h2>邀请更多好友，获得影响力值！</h2>
        </div>
      </div>
      <img :src="data.headimgurl" class="tx" />
      <div class="main_top clearfix">
        <ul class="clearfix">
          <li @click="switch_tab(1)" :class="{on: main_show==1}">
            <img v-if="main_show==1" src="@a/main33.png" />
            <img v-else src="@a/main3.png" />
            <p>影响力排行</p>
          </li>
          <li @click="switch_tab(2)" :class="{on: main_show==2}">
            <img v-if="main_show==2" src="@a/main22.png" />
            <img v-else src="@a/main2.png" />
            <p>活动详情</p>
          </li>
          <li @click="switch_tab(3)" :class="{on: main_show==3}">
            <img v-if="main_show==3" src="@a/main11.png" />
            <img v-else src="@a/main1.png" />
            <p>我的影响力</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="main_bottom" v-show="main_show==1">
        <ul class="main_ranking">
          <li class="clearfix">
            <span class="rank_ll rank_me">
                {{user_rank}}
              </span>
            <img :src="data.headimgurl" class="xtx" />
            <span class="rank_name">{{data.nickname}}</span>
            <span class="rank_right">
                已邀请 {{friend_rq}} 人
              </span>
          </li>
          <li class="clearfix" v-for="(item,index) in rank">
            <span class="rank_ll" v-show="index<3">
                <img src="https://themes-cdn.xjy.cn/statics/fission/images/xz1.png" v-show="index==0"/>
                <img src="https://themes-cdn.xjy.cn/statics/fission/images/xz2.png" v-show="index==1"/>
                <img src="https://themes-cdn.xjy.cn/statics/fission/images/xz3.png" v-show="index==2"/>
              </span>
            <span class="rank_ll" v-show="index>=3">
                {{index+1}}
              </span>
            <img :src="item.headimgurl" class="xtx" />
            <span class="rank_name">{{item.nickname}}</span>
            <span class="rank_right">
                已邀请 {{item.count}} 人
              </span>
          </li>
        </ul>
      </div>
      <div class="main_bottom main_details main_img" v-if="data.detail !='' && main_show==2" v-html="data.detail"></div>
      <div class="main_bottom main_details" v-show="data.detail =='' && main_show==2">
        <div v-show="activity_id==1">
          <p style="color: #494949;">职场中，你是否遇到过类似的问题？</p>
          <p style="color: #999;">“我入职三年，工资比不过新来的同事。”
            <br/> “我每天工作很努力，就因为不会表达，领导不器重我。”
            <br/> “我真的接受不了比我年龄小的人来指挥我。”
            <br/> “被老板器重也被老板绑架，希望你全年无休，不敢反抗，怕老板不满意，怕错过机会。”
          </p>
          <!-- <p style="color: #494949;"><a href="javascript:;" @click="show_poster()" style="color: #19439c; text-decoration: underline;">点击这里查看你的专属海报</a></p> -->
          <p style="color: #494949;">前段时间我们发起了“你的职场困惑”话题，收到400多人参与反馈。问题涉及范围很广，占比最多的4类问题分别是：升职加薪、人际关系、职业定位、能力提升。</p>
          <p style="color: #494949;">针对大家的问题，<span style="color: red">新精英决定开办【职场进阶】系列讲座，帮助你扫除职场认知盲点，提升职场通用技能，实现商业价值跃迁。</span></p>
          <p style="color: #494949;">第一期讲座我们在收集到的众多问题中，选择了最受职场人关注的</p>
          <p style="color: red;text-align:center"><strong>“涨薪”话题</strong></p>
          <p style="color: #494949;">升职加薪受多方面因素的影响，但领导绝对是最关键的一环。<span style="color: #333">那么升职加薪与领导的真实关系到底是怎样的呢？你是否知道领导决定员工升职加薪的标准是什么呢？</span></p>
          <p style="color: #494949;">本期讲座《专家帮你解读升职加薪与领导的关系》将全面解读上述问题，刷新你的职场认知。</p>
          <p style="color: red;">我们有幸邀请到资深职业生涯规划师王海英老师作为本期讲座的主讲人。</p>
          <p style="color: #494949; text-align: center;"><img src="@a/lec1.png" style="max-width: 100%;width: 75%; vertical-align: bottom;"></p>
          <p style="color: #494949;">王海英老师是国家二级心理咨询师，新精英生涯高级咨询师，企业EAP高级执行师，厦门市生涯规划与发展协会发起人之一。从业经验丰富，曾做过8年心理咨询及4年生涯咨询工作，咨询时数超过1000小时。</p>
          <p style="color: #494949;">本期讲座将于 <span style="color: red">2019年5月22日（周三）晚8点准时开讲</span>，讲座结束后会有答疑互动环节，咨询师的答疑相当于为你提供一次轻咨询，物超所值。</p>
          <p style="color: red;">讲座原价9.9元，现在只要获得1位好友扫码关注的助力，你就可以【免费参加】啦！</p>
          <p style="color: #494949;">讲座开始后，优惠活动入口将关闭，时不再来，抢占先机动作要快。</p>
          <p style="color: red;text-align:center"><strong>“涨薪”话题</strong></p>
          <p style="color: red;text-align:center">↓↓↓ 赶快扫描海报中的二维码吧 ↓↓↓</p>
          <p style="color: #494949; text-align: center;"><img :src="lec2" style="max-width: 100%; vertical-align: bottom;"></p>
        </div>
        <div v-show="activity_id==2">
          <p style="color: #494949; text-align: center;"><img src="@a/acv1.png" style="max-width: 100%; vertical-align: bottom;"></p>
          <p style="color: #494949;">最近，我们发起了“你的职场困惑”话题，累计收到了600多人的反馈。我们发现，除了职场通用型技能，大家还关心的一类话题是：如何完成职业进阶？</p>
          <p style="color: #494949;">在众多岗位中，产品经理是很多人想了解。</p>
          <p style="color: #999;"> 产品经理必须具备哪些个人修为？
            <br/> 做产品经理3-5年了，意味着什么？
            <br/> 产品经理职业生涯的关键点有哪些？如何把握？
            <br/> ......
          </p>
          <p style="color: #494949;">这期讲座，我们来聊聊大家关心的这些问题。</p>
          <p style="color: red;text-align:center"><strong>本期嘉宾</strong></p>
          <p style="color: #9d5322;text-align:center">星彻</p>
          <p style="color: #494949;">曾任高德开放平台产品专家；
            <br/> 融云科技公司产品副总裁；
            <br/> 微信开放平台高级产品经理；
            <br/> Discuz!社区产品经理。
          </p>
          <p style="color: #494949;">曾是微信春晚摇红包项目的发起人和执行负责人，
            <br/> 是腾讯体系内职级晋升最快的产品经理之一。
          </p>
          <p style="color: red;text-align:center"><strong>主讲内容</strong></p>
          <p style="color: #494949;">1.做产品经理3-5年，意味着什么？
            <br/> 2.产品经理，该有的个人修为
            <br/> 3.产品经理的出路
            <br/> 4.产品经理职业生涯关键点
          </p>
          <p style="color: red;text-align:center"><strong>如何报名</strong></p>
          <p style="color: #494949;">讲座环节：讲师分享+答疑互动
            <br/> 分享时间：2019年5月29日20：00
            <br/> 报名方式：
            <br/> 4.产品经理职业生涯关键点
          </p>
          <p style="color: red;">讲座原价9.9元，现在只要获得1位好友扫码关注的助力，你就可以【免费参加】啦！</p>
          <p style="color: #494949;">邀请人数最多的前10名同学，将获得价值99元的［7天职业发展特训营］免费入营资格。</p>
          <p style="color: red;text-align:center">↓↓↓ 扫码参加 ↓↓↓</p>
          <p style="color: #494949; text-align: center;"><img src="@a/acv2.png" style="max-width: 100%;width: 75%; vertical-align: bottom;"></p>
        </div>
      </div>
      <div class="main_bottom" v-show="main_show==3">
        <ul class="kt clearfix">
          <li>序号</li>
          <li>好友</li>
          <li style="text-align: center;padding-left: 20px;">加入时间</li>
        </ul>
        <ul class="main_ranking">
          <li class="clearfix" v-for="(item,index) in friend">
            <span class="rank_ll">
                {{index+1}}
            </span>
            <img :src="item.headimgurl" class="xtx" />
            <span class="rank_name">{{item.nickname}}</span>
            <span class="rank_right">
                {{item.time}}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="foot" v-show="main_show!=2" v-html="data.desc"></div>
  </div>
</template>
<script>
import axios from 'axios';
import {
  edu1_index,
  edu1_rank
} from '@/api/other'
import {
  coursedetail
} from '@/api/course';
let root = process.env.VUE_APP_ROOT;
let lec2img = (root == "main") ? require('../../../assets/career_activity1.jpeg') : require('../../../assets/coach_activity1.jpeg');

export default {
  data() {
      return {
        show_body: false,
        user_rank: "",
        data: {},
        main_show: 1,
        rank: [],
        loading: false,
        has_more: false,
        friend: [],
        friend_rq: "",
        lec2: lec2img,
        activity_id: ''
      }
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        this.activity_id = this.$route.query.id;
        edu1_index({
            activity_id: this.activity_id
          })
          .then((data) => {
            this.show_body = true;
            this.$toast.clear();
            this.user = data.user;
            this.data = data;
            this.rank = data.rank;
            this.has_more = data.has_more;
            this.user_rank = data.user_rank;
            this.friend = data.friend;
            this.friend_rq = data.friend.length || 0;
          })
      },
      backTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      switch_tab(main_show) {
        this.main_show = main_show;
        this.backTop();
        if (this.main_show == 1) {
          this.hash();
        }
      },
      hash() {
        if (this.has_more) {
          if (this.loading) {
          return false;
        };
        this.loading = true;
          this.$toast.loading({
            mask: true,
            message: "加载中..."
          })
          edu1_rank({
              activity_id: this.$route.query.id,
              count: this.rank.length
            })
            .then((data) => {
              for (let currJson in data.rank) {
                this.rank.push(data.rank[currJson]);
              };
              this.has_more = data.has_more;
              this.$toast.clear();
              this.loading = false;
            })
        }
      },
      onScroll() {
        //滚动监听
        window.onscroll = () => {
          let that = this;
          let marginBot = 0;
          if (document.documentElement.scrollTop) {
            let X = document.documentElement.scrollHeight;
            let Y = document.documentElement.scrollTop + document.body.scrollTop;
            let Z = document.documentElement.clientHeight;
            marginBot = X - Y - Z;
          } else {
            let J = document.body.scrollHeight;
            let I = document.body.scrollTop;
            let K = document.body.clientHeight;
            marginBot = J - I - K;
          }

          if (marginBot <= 0 && this.main_show == 1) {
            this.hash();
          }
        }
      }

    },
    created() {
      this.pullData();
    },
    mounted() {
      this.onScroll()
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bd_y {
  padding-top: changeRem(7.5)+px;
  padding-bottom: changeRem(4)+px;
}

.bd_x {
  padding-top: changeRem(7.5)+px;
  padding-bottom: changeRem(1)+px;
}

.top {
  width: 100%;
  max-width: 750px;
  background: -webkit-linear-gradient(#1d1c21, #3c3c3c);
  background: -o-linear-gradient(#1d1c21, #3c3c3c);
  background: -moz-linear-gradient(#1d1c21, #3c3c3c);
  background: linear-gradient(#1d1c21, #3c3c3c);
  padding: 0 changeRem(0.75)+px;
  padding-top: changeRem(1)+px;
  padding-bottom: changeRem(1)+px;
  position: fixed;
  top: 0;
  img.tx {
    float: right;
    width: changeRem(2.75)+px;
    height: changeRem(2.75)+px;
    border-radius: 50%;
  }
}

.top_left {
  float: left;
}

.rq {
  font-size: changeRem(0.55)+px;
  color: #feca05;
  float: left;
  margin-right: changeRem(0.25)+px;
  margin-top: changeRem(0.25)+px;
  span {
    font-size: changeRem(1.25)+px;
  }
}

.ry {
  border-left: 2px solid #616065;
  padding: changeRem(0.15)+px 0;
  padding-left: changeRem(0.2)+px;
  float: left;
  padding-top: changeRem(0.35)+px;
  h1 {
    font-size: changeRem(0.75)+px;
    color: #fff;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    display: inline-block;
    width: changeRem(7)+px;
  }
  h2 {
    font-size: changeRem(0.5)+px;
    color: #fff;
    line-height: 1;
    margin-top: changeRem(0.5)+px;
  }
}

.main_top {
  background: #fff;
  border-radius: changeRem(0.25)+px;
  padding: changeRem(0.3)+px 0;
  box-shadow: 0 changeRem(0.1)+px changeRem(0.2)+px changeRem(0.05)+px #ccc;
  position: absolute;
  bottom: changeRem(-2.25)+px;
  left: changeRem(0.75)+px;
  width: changeRem(13.5)+px;
  li {
    float: left;
    width: 33.33%;
    text-align: center;
    img {
      width: changeRem(1.25)+px;
      height: changeRem(1.25)+px;
    }
    p {
      font-size: changeRem(0.5)+px;
      color: #7a7a7a;
      margin-top: changeRem(0.3)+px;
    }
  }
  .on {
    color: #feca05;
  }
}

.main {
  width: 100%;
  padding: 0 changeRem(0.75)+px;
}

.main_bottom {
  background: #fff;
  border-radius: changeRem(0.25)+px;
  padding: 0 changeRem(0.6)+px;
  box-shadow: 0rem changeRem(0.2)+px changeRem(0.1)+px changeRem(0.05)+px #ccc;
}

.main_details {
  padding: changeRem(0.75)+px;
  p {
    font-size: changeRem(0.7)+px;
    color: #7a7a7a;
    line-height: changeRem(0.95)+px;
    margin-top: changeRem(0.75)+px;
  }
  img {
    width: 100%;
    margin-top: changeRem(0.5)+px;
  }
}

.main_ranking li {
  border-bottom: 2px solid #dadada;
  padding: changeRem(0.25)+px 0;
  .rank_ll {
    width: changeRem(1.6)+px;
    display: inline-block;
    text-align: center;
    font-size: changeRem(0.55)+px;
    color: #f9820d;
    img {
      width: changeRem(1)+px;
      height: changeRem(1)+px;
      vertical-align: middle;
    }
  }
  .rank_me {
    font-weight: bold;
  }
  img.xtx {
    width: changeRem(1)+px;
    height: changeRem(1)+px;
    margin: 0 changeRem(0.35)+px;
    vertical-align: middle;
    border-radius: 50%;
    margin-left: 0;
  }
  span.rank_name {
    font-size: changeRem(0.55)+px;
    color: #f9820d;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    display: inline-block;
    width: changeRem(5.5)+px;
    vertical-align: bottom;
  }
  span.rank_right {
    float: right;
    color: #f9500d;
    font-size: changeRem(0.55)+px;
    line-height: changeRem(1.1)+px;
  }
}

.jc {
  padding-top: 50px;
  text-align: center;
  color: #7a7a7a;
}

ul.kt {
  border-bottom: 2px solid #dadada;
  padding: changeRem(.25)+px 0;
  li {
    width: 33.33%;
    text-align: left;
    font-size: changeRem(.55)+px;
    color: #333;
    float: left;
    padding-left: changeRem(.35)+px;
  }
}

.foot {
  position: fixed;
  bottom: 0;
  background: #666;
  color: #fff;
  font-size: changeRem(.65)+px;
  padding: changeRem(.5)+px changeRem(.75)+px;
  line-height: changeRem(.85)+px;
  text-align: center;
  width: 100%;
  max-width: 750px;
  span {
    color: #f9500d;
  }
}

// 弹出卡片
.pop_card {
  background-color: transparent;
  text-align: center;
  img {
    width: changeRem(12)+px;
  }
  h3 {
    margin-top: changeRem(.8)+px;
    line-height: 1;
    color: #fff;
    font-size: changeRem(.52)+px;
    background-color: transparent;
  }
}
</style>
<style lang="scss">
.main_bottom.main_details.main_img {
  img {
    max-width: 100%;
  }
}
</style>
